import { ServiceCard } from '@/components/sv'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import * as Styled from '@/routes/template/styles'

export const TemplatePageFallback = () => {
  return (
    <Styled.Grid>
      <Styled.Header>
        <Skeleton className="size-[32px] rounded-full" />
        <Skeleton className="h-[32px] w-48" />
        <Skeleton className="ml-auto h-[32px] w-36" />
      </Styled.Header>
      <Styled.GridColumn>
        <Styled.DottedCanvas>
          <ServiceCard type="app" name="App" loading />
          <ServiceCard type="app" name="App" loading />
          <ServiceCard type="app" name="App" loading />
        </Styled.DottedCanvas>
        <Card>
          <CardHeader>
            <CardTitle>
              <H3>README</H3>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Skeleton className="h-8 w-1/3 mb-4" />
            <Skeleton className="h-4 w-full mb-2" />
            <Skeleton className="h-4 w-4/5 mb-2" />
            <Skeleton className="h-4 w-5/6 mb-2" />
            <Skeleton className="h-4 w-2/5 mb-2" />
            <Skeleton className="h-8 w-2/5 mt-8 mb-4" />
            <Skeleton className="h-4 w-5/6 mb-2" />
            <Skeleton className="h-4 w-full mb-2" />
            <Skeleton className="h-4 w-2/5 mb-2" />
            <Skeleton className="h-4 w-4/5 mb-2" />
          </CardContent>
        </Card>
      </Styled.GridColumn>
      <Styled.GridColumn>
        <Card>
          <CardHeader>
            <CardTitle>
              <H3>Metadata</H3>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Styled.MetadataGrid>
              <Skeleton className="size-4 rounded-full" />
              <Skeleton className="w-36 h-4" />
              <Skeleton className="size-4 rounded-full" />
              <Skeleton className="w-36 h-4" />
              <Skeleton className="size-4 rounded-full" />
              <Skeleton className="w-36 h-4" />
            </Styled.MetadataGrid>
          </CardContent>
        </Card>
      </Styled.GridColumn>
    </Styled.Grid>
  )
}
